var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      { staticClass: "breadcrumb" },
      [
        _c(
          "el-breadcrumb",
          { attrs: { separator: "" } },
          [
            _c("el-breadcrumb-item", [
              _c("div", { staticClass: "div1" }, [_vm._v("数据查询")]),
            ]),
            !_vm.title
              ? _c(
                  "el-breadcrumb-item",
                  { attrs: { to: { name: "orderStatistics" } } },
                  [_c("div", { staticClass: "div3" }, [_vm._v("订单统计数据")])]
                )
              : _vm._e(),
            !_vm.title
              ? _c("el-breadcrumb-item", [
                  _c("div", { staticClass: "div2" }, [_vm._v("订单详情")]),
                ])
              : _vm._e(),
            _vm.title
              ? _c("el-breadcrumb-item", [
                  _c(
                    "div",
                    {
                      staticClass: "div1",
                      on: {
                        click: function ($event) {
                          return _vm.$router.back(-1)
                        },
                      },
                    },
                    [_vm._v(" 客户管理 ")]
                  ),
                ])
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser) && _vm.title
              ? _c(
                  "el-breadcrumb-item",
                  {
                    attrs: {
                      to: {
                        name: "customerListOrder",
                        query: { id: _vm.content.orderUser.userId },
                      },
                    },
                  },
                  [_c("div", { staticClass: "div3" }, [_vm._v("客户订单")])]
                )
              : _vm._e(),
            _vm.title
              ? _c("el-breadcrumb-item", [
                  _c("div", { staticClass: "div2" }, [_vm._v("订单详情")]),
                ])
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
    !_vm.is_null(_vm.content)
      ? _c("div", { staticClass: "money" }, [
          _vm._m(0),
          _c("div", { staticClass: "contentTotal" }, [
            _c("p", [
              _c("span", [
                _vm._v("已收金额：￥" + _vm._s(_vm.content.receivedAmount)),
              ]),
            ]),
            _c("p", [
              _c("span", [
                _vm._v("待收金额：￥" + _vm._s(_vm.content.waitAmount)),
              ]),
            ]),
            _c("p", [
              _c("span", [
                _vm._v("优惠金额：￥" + _vm._s(_vm.content.preferentialAmount)),
              ]),
            ]),
            _c("p", [
              _c("span", [
                _vm._v("总金额：￥" + _vm._s(_vm.content.payAmount)),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "state" }, [
      !_vm.is_null(_vm.content)
        ? _c("p", { staticClass: "header" }, [_c("span", [_vm._v("订单状态")])])
        : _vm._e(),
      _c("ul", [
        _c("li", [
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v(
                  " 订单状态 : " +
                    _vm._s(
                      _vm.content.orderStatus == 1
                        ? "待备货"
                        : "" || _vm.content.orderStatus == 2
                        ? "待发货"
                        : "" || _vm.content.orderStatus == 3
                        ? "待签收"
                        : "" || _vm.content.orderStatus == 4
                        ? "已备货"
                        : ""
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v("客户姓名 : " + _vm._s(_vm.content.customerName)),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v("客户电话 :" + _vm._s(_vm.content.customerPhone)),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v("客户电话 : " + _vm._s(_vm.content.customerPhone)),
              ])
            : _vm._e(),
        ]),
        _c("li", [
          !_vm.is_null(_vm.content)
            ? _c("p", [_vm._v("下单时间 : " + _vm._s(_vm.content.payTime))])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [_vm._v("订单编号 : " + _vm._s(_vm.content.orderNo))])
            : _vm._e(),
        ]),
        _c(
          "li",
          [
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder) &&
            _vm.content.orderUser.logisticsOrder.orderStatus == "1" &&
            _vm.parArray.indexOf("dqskhqs") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.customerSign },
                  },
                  [_vm._v("客户签收")]
                )
              : _vm._e(),
            !_vm.is_null(_vm.content.orderUser) &&
            !_vm.is_null(_vm.content.orderUser.logisticsOrder) &&
            _vm.content.orderUser.logisticsOrder.orderStatus == "2" &&
            _vm.parArray.indexOf("yqsxgwwqs") != -1
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "mini" },
                    on: { click: _vm.cancelSign },
                  },
                  [_vm._v("修改未签收")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
    _c("div", { staticClass: "address" }, [
      _c("p", { staticClass: "header" }, [_vm._v("收货人信息")]),
      _c("ul", [
        _c("li", [
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v("收货人姓名：" + _vm._s(_vm.content.receiptName)),
              ])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [_vm._v("联系电话：" + _vm._s(_vm.content.receiptPhone))])
            : _vm._e(),
          !_vm.is_null(_vm.content)
            ? _c("p", [
                _vm._v("收货地址：" + _vm._s(_vm.content.receiptAddress)),
              ])
            : _vm._e(),
        ]),
        _vm.content
          ? _c("li", [
              !_vm.is_null(_vm.content.remark)
                ? _c("p", [_vm._v("备注：" + _vm._s(_vm.content.remark))])
                : _vm._e(),
              _vm.is_null(_vm.content.remark)
                ? _c("p", [_vm._v("备注：无")])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "orderBox" },
      [
        _c("p", { staticClass: "header" }, [_vm._v("订单商品")]),
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.commodity } },
          [
            _c("el-table-column", {
              attrs: { prop: "productName", label: "商品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productNum", label: "商品数量", width: "180" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productUnitPrice", label: "商品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productBrand", label: "商品品牌" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productType", label: "商品分类" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productSpec", label: "商品规格" },
            }),
            _c("el-table-column", {
              attrs: { label: "商品小计" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            Number(props.row.productNum) *
                              Number(props.row.productUnitPrice)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "el-table",
          { staticStyle: { width: "100%" }, attrs: { data: _vm.gift } },
          [
            _c("el-table-column", {
              attrs: { prop: "productName", label: "赠品名称" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productNum", label: "赠品数量", width: "180" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productUnitPrice", label: "赠品单价" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productBrand", label: "赠品品牌" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productType", label: "赠品分类" },
            }),
            _c("el-table-column", {
              attrs: { prop: "productSpec", label: "赠品规格" },
            }),
            _c("el-table-column", {
              attrs: { label: "赠品小计" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            Number(props.row.productNum) *
                              Number(props.row.productUnitPrice)
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "total" }, [
      !_vm.is_null(_vm.content)
        ? _c("p", [_vm._v("总计：共 " + _vm._s(_vm.number) + " 件")])
        : _vm._e(),
      !_vm.is_null(_vm.content)
        ? _c("p", [_vm._v("运费：" + _vm._s(_vm.content.freightAmount))])
        : _vm._e(),
      !_vm.is_null(_vm.aggregate)
        ? _c("p", [_vm._v("总价：" + _vm._s(_vm.aggregate))])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "headerNav" }, [
      _c("span", [_vm._v("金额状态")]),
      _c("div", { staticClass: "right" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }